import { render, staticRenderFns } from "./EnvironmentalsSection.vue?vue&type=template&id=7bebb150"
import script from "./EnvironmentalsSection.vue?vue&type=script&lang=js"
export * from "./EnvironmentalsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports